<template>
  <v-layout child-flex row wrap>
    <div v-if="isAdmin">
      <CompetitionForm v-bind:isNew="true"/>
    </div>

    <v-flex
      v-for="(item, key, index) in competitions"
      :key="key"
      v-bind="{ [`xs${flexlist[index%5]}`]: true }"
    >
      <v-card @click.native="clickTo(key)">
        <v-img
          :src="item.imageUrl"
          position="top"
          height="200px"
          gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
        >
          <v-container fill-height fluid pa-2>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <span class="headline white--text" v-text="item.name"></span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>

        <v-card-title>
          <div>
            <span
              class="grey--text"
            >Running from {{dateFormat(item.startDate)}} till {{dateFormat(item.endDate)}}</span>
            <br>
            <span>{{item.description}}</span>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-btn flat color="pink" :to="{name:'Competition', params: {id:key}}">Explore</v-btn>
          <v-spacer></v-spacer>
          <v-tooltip top v-if="item.matFiles">
            <template #activator="data">
              <v-btn icon v-on="data.on" v-bind:href="item.matFiles">
                <v-icon>fas fa-download</v-icon>
              </v-btn>
            </template>
            <span>Download Mat Files</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import CompetitionForm from "@/components/CompetitionForm";
import { mapGetters } from "vuex";
export default {
  name: "Competitions",
  components: {
    CompetitionForm
  },
  data: () => ({
    flexlist: [12, 6, 6, 6, 6]
  }),
  created() {

    if (this.$route.params.noid) {
      console.log("HAS NO ID: " + this.$route.params.noid)
    } else {
      console.log("Competitions no NO context")
    }

  },
  computed: {
    ...mapGetters(["isAdmin", "competitions"]),
  },
  methods: {
    dateFormat(_date) {
      return new Date(_date).toDateString();
    },
    clickTo(_id) {
      this.$router.push({ name: "Competition", params: { id: _id } });
    }
  }
};
</script>
